/***
**Module Name: add/edit client
 **File Name :  editclient.js
 **Project :    Orasi Media
 **Copyright(c) : X Platform Consulting.
 **Organization : Peafowl Inc
 **author :  chandrasekhar
 **author :  Hari
 **license :
 **version :  1.0.0
 **Created on :
 **Created on: Dec 29 2022
 **Last modified on: Dec 29 2022
 **Description : contains add/edit client data.
 ***/
import React, { useState, useEffect, useContext } from "react";
import Footer from "../../components/dashboard/footer";
import Header from "../../components/dashboard/header";
import Sidebar from "../../components/dashboard/sidebar";
import tmdbApi from "../../api/tmdbApi";
import SweetAlert from 'react-bootstrap-sweetalert';
import { useNavigate, Link } from "react-router-dom";
import { useParams } from 'react-router-dom';
import axios from "axios";
import { contentContext } from "../../context/contentContext";
import Loader from "../../components/loader";
import DataTable from 'react-data-table-component';

import * as Config from "../../constants/Config";

import moment from "moment";
import SessionPopup from "../SessionPopup"
//  import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import TableLoader from "../../components/tableLoader";
import StripePayoutsPanel from "../../components/stripe/StripePayoutsPanel";
import { mayViewFinance } from "../../utils/adminRoles";
let { lambda, country, appname } = window.app;

const ViewClient = () => {
    const navigate = useNavigate();
    let { id } = useParams();
    const [nda, setNda] = useState(false);
    const [agreement, setAgreement] = useState(false);
    const [show, setShow] = useState(true);
    const [countries, setCountries] = useState('');

    const [error, setError] = useState("");
    const [add, setAdd] = useState(false);
    const [success, setSuccess] = useState(false);
    const [updated, setUpdated] = useState(false);
    const [message, setMessage] = useState(false);
    const [valid, setValid] = useState(true);
    const [folowupcontent, setFollowupContent] = useState([]);
    const [account, setAccount] = useState([]);
    const [lastStatus, setLastStatus] = useState("");

    const [company, setCompany] = useState([]);
    const [companyValue, setCompanyValue] = useState({});
    const [editUser, setEditUser] = useState({ companyname: '', email: '' });
    const [companyId, setCompanyId] = useState("");
    const [companyDeatilsList, setCompanyDetailsList] = useState({});
    const [showSessionPopupup, setShowSessionPopupup] = useState(false);
    const [invalidContent, setInvalidContent] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const { route, setRoute, setCurrentPage, setRowsPerPage, usePrevious, userData, setActiveMenuId, setActiveMenuObj, GetTimeActivity } = useContext(contentContext);
    const [storesData, setStoresData] = useState([])

    const prevRoute = usePrevious(route)
    useEffect(() => {
        if (prevRoute !== undefined && prevRoute != route) {
            setCurrentPage(1)
            setRowsPerPage(15)
        }
    }, [prevRoute]);
    // console.log('prevRoute--->',prevRoute)
    // console.log('currentRoute--->',route)

    const columns = [

        {
            name: 'Name',
            selector: row => row?.name ?? "",
            sortable: true,
        },
        {
            name: 'Address',
            selector: row => row?.businessaddress ?? "",
            sortable: true,
        },


        {
            name: 'Created on',
            selector: row => row?.created,
            sortable: true,
            cell: (props) => props.created ? moment.utc(props.created).format("MM-DD-YYYY") : "",
            // sortFunction: (a, b) => moment(a.created).diff(b.created),
        },
        {
            name: 'status',
            selector: row => row?.status ?? "",
            sortable: true,
        },

        // {
        //     name:
        //         //  <>
        //         // {(subValDashboard && subValDashboard.view && subValDashboard.view.display === true) || (subValDashboard && subValDashboard.edit && subValDashboard.edit.display === true) ? 
        //         // 'Actions' : null}</>
        //         'Actions'
        //     ,
        //     cell: (props) =>
        //         //  {
        //         //      subValDashboard && subValDashboard.view && subValDashboard.edit && (subValDashboard.view.display === true || subValDashboard.edit.display === true) &&
        //         <div className="d-flex">
        //             {/* {subValDashboard && subValDashboard.view && subValDashboard.view.display === true && */}
        //             <a onClick={e => handleViewClient(e, props.clientid)}
        //                 //  className={`${subValDashboard && subValDashboard.view && subValDashboard.view.enable === false ? 'pe-none' : ''} text-success action-button`}

        //                 className={` text-success action-button`}
        //             ><i className="mdi mdi-eye font-size-18"></i></a>
        //             {/* } */}
        //             {/* {subValDashboard && subValDashboard.edit && subValDashboard.edit.display === true && */}
        //             <a onClick={e => handleEditClient(e, props.clientid)} style={{ position: "inherit" }}
        //                 // className={`${subValDashboard && subValDashboard.edit && subValDashboard.edit.enable === false ? 'pe-none' : ''} text-danger action-button`}
        //                 className={`text-danger action-button`}
        //             ><i className="mdi mdi-pencil font-size-18"></i></a>
        //             {/* } */}
        //         </div>
        //     //  }
        //     ,
        //     ignoreRowClick: true,
        //     allowOverflow: true,
        //     button: true,
        // },
    ];

    useEffect(() => {
        if (!localStorage.getItem("token")) {
            navigate("/");
        }
        setRoute("client")
        setActiveMenuId(200001)
        // setActiveMenuObj({
        //     "Client Management": true,
        //     "Contact Management":false,
        //     "Reports": false
        // })
        if (id) {
            setAdd(false);
            getclient();
            getStore();
        } else {
            // setAdd(true);

        }
        //   GetCountries();
        userActivity();
    }, []);

    const customNoRecords = () => {
        return (

            <div className="empty-state-body empty-record"  >
                <div className="empty-state__message">
                    <span className="material-icons">summarize</span>
                    <p className="form-check font-size-16">No locations are available</p>
                </div> </div>
        )
    }

    const getStore = (e) => {
        // GetTimeActivity()
        const token = localStorage.getItem("token")
        // const userdata = localStorage.getItem("userdata")
        // console.log('userdata--->',userdata.username)
        // let userToken = userdata && userdata.token
        // console.log('userToken--->',userToken)
        axios({
            method: 'POST',
            url: `${lambda}/getStores?appname=${appname}&clientid=${id}&token=${token}`,
            // + "&token=" + token,
        })
            .then(function (response) {
                if (response?.data?.result === "Invalid token or Expired") {
                    setShowSessionPopupup(true)
                } else {
                    if (response?.data?.result.length > 0) {
                        const result = response?.data?.result;
                        // setIsLoading(false)
                        setStoresData(result)
                    } else {
                        // setInvalidContent(true)
                        // setIsLoading(false)
                        // setLocationData(response?.data?.result)
                    }

                }

                // setDisableSaveBtn(false)
            });
    }
    const userActivity = () => {
        let path = window.location.pathname.split("/");
        const pageName = path[path.length - 2];
        var presentTime = moment();
        let payload;

        payload = {
            "userid": localStorage.getItem("userId"),
            "pagename": pageName,
            "pageurl": window.location.href,
            "starttime": presentTime,
            "useragent": JSON.parse(localStorage.getItem("loc"))

        };


        const previousId = localStorage.getItem("previousid");
        const urlLink = lambda + '/useractivity?appname=' + appname + (previousId ? "&previousid=" + previousId : "");


        axios({
            method: 'POST',
            url: urlLink,
            data: payload
        })
            .then(function (response) {
                if (response?.data?.statusCode === 200) {
                    localStorage.setItem("previousid", response?.data?.result)
                }
            });
    }
    const GetCountries = async () => {
        try {

            const response = await tmdbApi.getLookUp({
                "type": ["country"],
                "sortBy": "alpha3",
                "projection": "tiny"
            });
            setCountries(response?.result.data);

        } catch {
            console.log("error");
        }
    };



    // useEffect(() => {
    //     if (id) {
    //         // getFollowup();
    //     }
    // }, [updated]);


    // const getclient = (e) => {
    //     GetTimeActivity()
    //     const token = localStorage.getItem("token")
    //     setIsLoading(true)
    //     axios({
    //         method: 'GET',
    //         url: lambda + '/clientInfo?appname=' + appname + '&clientid=' + id
    //         // + "&token=" + token,
    //     })
    //         .then(function (response) {
    //             if (response?.data?.result === "Invalid token or Expired") {
    //                 setShowSessionPopupup(true)
    //             } else {
    //                 if (response?.data?.result.length > 0) {
    //                     const result = response?.data?.result?.[0];
    //                     setLastStatus(result?.status)


    //                     const filterObj = result

    //                     if (filterObj?.phone === "" || filterObj?.phone === undefined || filterObj?.phone === null || filterObj?.phone.trim() === "") {
    //                         const idcValue = `${filterObj?.phone === "" || filterObj?.phone === undefined || filterObj?.phone === null || filterObj?.phone.trim() === "" ? "" : filterObj?.idc}`
    //                         const formvalues = { ...filterObj, idc: idcValue }

    //                         setEditUser(formvalues);
    //                     } else {
    //                         setEditUser(filterObj);

    //                     }

    //                 } else {
    //                     setInvalidContent(true)
    //                 }
    //             }



    //         });
    // }

    const getclient = async (e) => {
        try {
            GetTimeActivity();
            const token = localStorage.getItem("token");

            setIsLoading(true);

            const response = await axios({
                method: 'GET',
                url: `${lambda}/clientInfo?appname=${appname}&clientid=${id}`,
                // headers: { Authorization: token }, // if needed later
            });

            if (response?.data?.result === "Invalid token or Expired") {
                setShowSessionPopupup(true);
                return;
            }

            if (response?.data?.result?.length > 0) {
                const result = response.data.result[0];
                setLastStatus(result?.status);

                const filterObj = result;

                if (
                    !filterObj?.phone ||
                    filterObj.phone.trim() === ""
                ) {
                    const idcValue = filterObj?.idc || "";
                    const formvalues = { ...filterObj, idc: idcValue };
                    setEditUser(formvalues);
                } else {
                    setEditUser(filterObj);
                }
            } else {
                setInvalidContent(true);
            }

        } catch (error) {
            console.error("Error fetching client info:", error);

            // optional: user-facing error handling
            setInvalidContent(true);

        } finally {
            // ✅ loader always stops
            setIsLoading(false);
        }
    };

    const onclickInvalid = () => {
        GetTimeActivity()
        setInvalidContent(false)
        navigate('/clients')
    }



    const getFollowup = (e) => {
        GetTimeActivity()
        const token = localStorage.getItem("token")
        axios({
            method: 'GET',
            url: lambda + '/followup?appname=' + appname + '&clientid=' + id + "&token=" + token,
        })
            .then(function (response) {
                if (response?.data?.result === "Invalid token or Expired") {
                    setShowSessionPopupup(true)
                } else {
                    setFollowupContent(response?.data?.result?.data);

                }
            });
    }


    const handleEditUser = (e, paramuserid) => {
        e.preventDefault(); // prevent default click behavior
        if (!paramuserid) {
            console.warn('User ID not found for editing');
            return;
        }
        console.log('paramuserid', paramuserid);
        GetTimeActivity();
        navigate("/editclient/" + paramuserid);
    }

    const handleBack = () => {
        GetTimeActivity()
        navigate({
            pathname: "/clients",
            state: { search: true }
        });
    }
    let k = editUser && editUser?.idc && countries && countries?.length > 0 && countries?.filter(eachItem => eachItem.alpha3 === editUser?.idc)
    let Code = k && k[0] && k[0].countrycode !== undefined ? (k && k[0] && k[0].countrycode).toString() : ""
    // const idcValue = editUser && (editUser?.idc !== "" && editUser?.idc !== undefined ) ? editUser?.idc +''+ Code : "select";
    const idcValue = editUser?.idc;
    // `US(+${editUser?.idc})`;
    // const usersPermission = editUser?.permissions?.find(p => p.menu === "Clients");
    const usersPermission = userData && userData.permissions && userData.permissions.length > 0 && userData.permissions.filter(eachItem => eachItem.menu === "Clients")
    const displayEdit = usersPermission?.[0]?.dashboard?.edit?.display === true;
    const enableEdit = usersPermission?.[0]?.dashboard?.edit?.enable === true;

    console.log("editUser", usersPermission)
    return (
        <>
            {showSessionPopupup && <SessionPopup />}
            <div id="layout-wrapper">
                <Header />
                <Sidebar />
                <SweetAlert show={invalidContent}
                    custom
                    confirmBtnText="ok"
                    confirmBtnBsStyle="primary"
                    title={"Clients Not Found"}
                    onConfirm={e => onclickInvalid()}
                >
                </SweetAlert>
                {!invalidContent &&
                    <div className="main-content create-user edit-content add-client">

                        <div className="page-content ">
                            <div className="container-fluid">



                                <div className="row mb-4 breadcrumb">
                                    <div className="col-lg-12">
                                        <div className="d-flex align-items-center">
                                            <div className="flex-grow-1">
                                                <h4 className="mb-2 card-title">VIEWkk CLIENT</h4>
                                                {/* <p className="menu-path">Client Management / <b>View Client 
                                            <button
                                                                onClick={e => handleEditUser(e, editUser?.clientid)}
                                                                id="client-view-edit-button"
                                                                className="btn btn-sm btn-outline-danger ms-2"
                                                                style={{ padding: "2px 6px", verticalAlign: "middle" }}
                                                                title="Edit Client"
                                                            >
                                                                <i className="mdi mdi-pencil font-size-14"></i>
                                                            </button>
                                                </b></p> */}
                                                <p className="menu-path d-flex align-items-center">
                                                    <span>Client Management</span> /
                                                    <b>
                                                        View Client </b>
                                                    {/* <button
                                                        onClick={e => canEditUser && handleEditUser(e, editUser?.clientid)}
                                                        id="user-viewedit-button"
                                                        className="stroke-btn-style ms-2"
                                                        style={{
                                                            padding: "2px 6px",
                                                            verticalAlign: "middle",
                                                            position: "relative",
                                                            cursor: canEditUser ? "pointer" : "not-allowed",
                                                            borderRadius: "5px",
                                                            opacity: canEditUser ? 1 : 0.5
                                                        }}
                                                        title={canEditUser ? "Edit User" : "Edit Not Allowed"}
                                                        disabled={!canEditUser}
                                                    >
                                                        <span className="material-symbols-outlined">edit</span>
                                                    </button> */}
                                                    {displayEdit && (
                                                        <button
                                                            onClick={e => {
                                                                if (enableEdit) {
                                                                    handleEditUser(e, editUser?.clientid);
                                                                }
                                                            }}
                                                            id="user-viewedit-button"
                                                            className="stroke-btn-style ms-2"
                                                            style={{
                                                                padding: "2px 6px",
                                                                verticalAlign: "middle",
                                                                position: "relative",
                                                                cursor: enableEdit ? "pointer" : "not-allowed",
                                                                borderRadius: "5px",
                                                                opacity: enableEdit ? 1 : 0.5
                                                            }}
                                                            title={enableEdit ? "Edit Client" : "Edit Not Allowed"}
                                                            disabled={!enableEdit}
                                                        >
                                                            <span className="material-symbols-outlined">edit</span>
                                                        </button>
                                                    )}



                                                </p>
                                            </div>
                                            <div>
                                                <a onClick={handleBack} className="stroke-btn-style"><span className="material-symbols-outlined">arrow_back</span>Back</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="create-user-block">

                                    <div className="form-block">
                                        <ul className="nav nav-tabs nav-tabs-custom nav-justified" role="tablist">
                                            <li className="nav-item" role="presentation">
                                                <a className="nav-link active" data-bs-toggle="tab" href="#home1" role="tab" aria-selected="true">
                                                    <span className="d-block d-sm-none"><i className="fas fa-home"></i></span>
                                                    <span className="d-none d-sm-block">DETAILS</span>
                                                </a>
                                            </li>
                                            {/* {add === false && editUser?.status !== 'ACTIVE' ? */}
                                            <>
                                                {/* <li className="nav-item" role="presentation">
                                                 <a className="nav-link" data-bs-toggle="tab" href="#profile1" role="tab" aria-selected="false" tabIndex="-1">
                                                     <span className="d-block d-sm-none"><i className="far fa-user"></i></span>
                                                     <span className="d-none d-sm-block">DOCUMENTS</span>
                                                 </a>
                                             </li> */}
                                                <li className="nav-item" role="presentation">
                                                    <a className="nav-link" data-bs-toggle="tab" href="#messages1" role="tab" aria-selected="false" tabIndex="-1">
                                                        <span className="d-block d-sm-none"><i className="far fa-envelope"></i></span>
                                                        <span className="d-none d-sm-block">FOLLOW UP</span>
                                                    </a>
                                                </li></>
                                            {/* : ""} */}
                                            <li className="nav-item" role="presentation">
                                                <a className="nav-link" data-bs-toggle="tab" href="#stores" role="tab" aria-selected="false" tabIndex="-1">
                                                    <span className="d-block d-sm-none"><i className="far fa-envelope"></i></span>
                                                    <span className="d-none d-sm-block">Locations</span>
                                                </a>
                                            </li>
                                            {/* <li className="nav-item" role="presentation">
                                                        <button
                                                            type="button"
                                                            className={`nav-link ${activeTab === "stores" ? "active" : ""}`}
                                                            role="tab"
                                                            onClick={() =>
                                                                guardUnsavedChanges(() => setActiveTab("stores"))
                                                            }
                                                        >
                                                            <span className="d-block d-sm-none">
                                                                <i className="far fa-envelope"></i>
                                                            </span>
                                                            <span className="d-none d-sm-block">Locations</span>
                                                        </button>
                                                    </li> */}



                                        </ul>
                                        {isLoading ? <TableLoader /> :
                                            <div className="tab-content p-3 text-muted">
                                                <div className="tab-pane active show" id="home1" role="tabpanel">
                                                    {/* {Object.keys(editUser).length > 0 && countries?.length >0 ?  */}
                                                    <>
                                                        <div className="row">
                                                            <h5 className="form-title"> basic details</h5>
                                                            <div className="col-md-6">
                                                                <div className="input-field">
                                                                    <label className="form_label">BUSINESS NAME</label>
                                                                    <input className="form-control" type="text" name="name" value={editUser?.businessname} id="example-text-input" disabled />
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <div className="input-field">
                                                                    <label className="form_label">CONTACT NAME</label>
                                                                    <input className="form-control" type="text" name="contactname" value={editUser?.contactname} id="example-text-input" disabled />
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <div className="input-field">
                                                                    <label className="form_label">EMAIL</label>

                                                                    <input className="form-control contact-number" type="email" value={editUser?.emailId} id="example-email-input" disabled />

                                                                </div>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <div className="input-field">
                                                                    <label className="form_label">contact number</label>
                                                                    <div className="country-code">
                                                                        <input className="form-control phonenumber" style={{
                                                                            width: "25%",
                                                                            borderRadius: "5px 0px 0px 5px"
                                                                        }} type="email" value={idcValue} id="example-email-input" disabled />


                                                                        <input className="form-control numberfiled" type="tel" name="phone" value={editUser?.phone} placeholder="Enter Phone Number" maxLength="10" id="example-tel-input" disabled />
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="col-md-6">
                                                                <div className="input-field">
                                                                    <label className="form_label">subscriptions</label>

                                                                    <input className="form-control contact-number" type="email" value={editUser?.subscription} id="example-email-input" disabled />


                                                                </div>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <div className="input-field">
                                                                    <label className="form_label" id="plans-label">
                                                                        Plan Type

                                                                        {/* <span className="required">*</span> */}
                                                                    </label>

                                                                    <select
                                                                        // disabled={editUser?.status === "ACTIVE"}
                                                                        className="form-select"
                                                                        name="plantype"
                                                                        // onChange={(e) => handleChange(e)}
                                                                        value={editUser?.plantype}
                                                                        id="plans-select"
                                                                        disabled
                                                                    >
                                                                        <option value="" id="plan-option-default">Select Plan Type</option>
                                                                        <option value="Monthly">Monthly</option>
                                                                        <option value="Yearly">Yearly</option>
                                                                    </select>


                                                                </div>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <div className="input-field">
                                                                    <label className="form_label">Business Address</label>

                                                                    <input className="form-control contact-number" type="email" value={editUser?.businessaddress} id="example-email-input" disabled />


                                                                </div>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <div className="input-field">
                                                                    <label className="form_label">City</label>

                                                                    <input
                                                                        className="form-control contact-number"
                                                                        type="text"
                                                                        value={editUser?.city || editUser?.businessaddress?.split(",")[0] || ""}
                                                                        disabled
                                                                    />
                                                                </div>
                                                            </div>

                                                            <div className="col-md-6">
                                                                <div className="input-field">
                                                                    <label className="form_label">Flat Fee</label>

                                                                    <input className="form-control contact-number" type="text" value={editUser?.flatFee} id="example-email-input" disabled />


                                                                </div>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <div className="input-field">
                                                                    <label className="form_label" id="business-name-label">Commission Percentage
                                                                        {/* <span className="required">*</span> */}
                                                                    </label>
                                                                    <input className="form-control" placeholder="Enter Percentage" type="text" name="commissionpercentage" value={editUser?.commissionpercentage} id="business-name-input" disabled />
                                                                    {/* {percentError !== "" ? <span className="errormsg" id="business-name-error" style={{ fontWeight: 'bold', color: 'red' }}>{percentError}</span> : ""} */}
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <div className="input-field">
                                                                    <label className="form_label" id="plans-label">Settelment
                                                                        {/* <span className="required">*</span> */}
                                                                    </label>
                                                                    <select
                                                                        disabled
                                                                        className="form-select"
                                                                        name="settelment"
                                                                        // onChange={(e) => handleChange(e)}
                                                                        value={editUser?.settelment}
                                                                        id="plans-select"
                                                                    >
                                                                        <option value="" id="plan-option-default">Select </option>
                                                                        <option value="week" id="plan-option-week">Week</option>
                                                                        <option value="15-days" id="plan-option-15-days">15 Days</option>
                                                                        <option value="one-month" id="plan-option-one-month">One Month</option>

                                                                    </select>

                                                                    {/* {daysError !== "" ? <span className="errormsg" id="plans-error" style={{ fontWeight: 'bold', color: 'red' }}>{daysError}</span> : ""} */}
                                                                </div>
                                                            </div>
                                                            {/* <div className="col-md-6">
                                                    <div className="input-field">
                                                        <label className="form_label">entity</label>

                                                        <input className="form-control contact-number" type="email" value={editUser?.entity} id="example-email-input" disabled />


                                                    </div>
                                                </div> */}


                                                            {/* <div className="col-md-6">
                                                    <div className="input-field">
                                                        <label className="form_label">Company Name</label>


                                                        <input className="form-control" name="companyname" placeholder="Enter Company Name" type="text" value={editUser?.companyname} id="example-text-input" disabled />


                                                    </div>
                                                </div> */}
                                                            {add === false && editUser && editUser?.companydetails && editUser?.companydetails[0] && editUser?.companydetails?.[0].accountmanager &&
                                                                <div className="col-md-6">
                                                                    <div className="input-field">
                                                                        <label className="form_label">Account Manager</label>
                                                                        <input className="form-control" placeholder="Enter Name" type="text" name="name" value={editUser?.companydetails?.[0].accountmanager
                                                                            //  editUser && editUser?.companydetails && editUser?.companydetails[0] && editUser?.companydetails[0].accountmanager
                                                                        } id="example-text-input" disabled />

                                                                    </div>
                                                                </div>
                                                            }

                                                        </div>


                                                        <div className="row comment-section created">
                                                            {editUser?.created &&
                                                                <div className="col-md-4">
                                                                    <label className="form_label">Created On</label>
                                                                    <input className="form-control" placeholder="Enter Name" type="text" value={editUser.created ? moment.utc(editUser.created).format("MM-DD-YYYY") : ""} id="example-text-input" disabled />
                                                                </div>
                                                            }
                                                            {editUser?.termsAccptedOn &&
                                                                <div className="col-md-4">
                                                                    <label className="form_label">Terms Accepted On</label>
                                                                    <input className="form-control" placeholder="Enter Name" type="text" value={new Date(editUser?.termsAccptedOn).toLocaleDateString('en-IN', {
                                                                        day: 'numeric',
                                                                        month: 'short',
                                                                        year: 'numeric',
                                                                        hour: 'numeric',
                                                                        minute: 'numeric',
                                                                    })} id="example-text-input" disabled />
                                                                </div>
                                                            }
                                                            {editUser?.approvedOn &&
                                                                <div className="col-md-4">
                                                                    <label className="form_label">Approved On</label>
                                                                    <input className="form-control" placeholder="Enter Name" type="text" value={new Date(editUser?.approvedOn).toLocaleDateString('en-IN', {
                                                                        day: 'numeric',
                                                                        month: 'short',
                                                                        year: 'numeric',
                                                                        hour: 'numeric',
                                                                        minute: 'numeric',
                                                                    })} id="example-text-input" disabled />
                                                                </div>
                                                            }
                                                            {/* {editUser?.verificationCode &&
                                                            <div className="col-md-4">
                                                                <label className="form_label">Verification Code</label>
                                                                <input className="form-control" placeholder="Enter Name" type="text" value={editUser?.verificationCode} id="example-text-input" disabled />
                                                            </div>
                                                        } */}
                                                            {editUser?.otp &&
                                                                <div className="col-md-4">
                                                                    <label className="form_label">OTP</label>
                                                                    <input className="form-control" placeholder="Enter Name" type="text" value={editUser?.otp} id="example-text-input" disabled />
                                                                </div>
                                                            }
                                                        </div>

                                                        <div className="row status client_status">

                                                            <div className="col-md-3 justify-content-between ps-0">

                                                                <div className="input-field d-flex align-items-center">

                                                                    <label className="form_label">Status</label>
                                                                    {lastStatus === "REJECT" ?
                                                                        <>
                                                                            <input className="form-control contact-number" type="text" value="REJECTED" id="example-email-input" disabled />

                                                                            {/* <a className="roll-back fill-btn-style"><span class="material-icons-outlined">history</span>RollBack</a> */}

                                                                            <div className="pre_status d-flex align-items-center">
                                                                                <label className="form_label">Previous Status</label>
                                                                                <input className="form-control contact-number" type="text" value={editUser?.previousStatus} id="example-email-input" disabled />
                                                                            </div></>
                                                                        :

                                                                        <input className="form-control contact-number" type="email" value={editUser?.status} id="example-email-input" disabled />

                                                                    }



                                                                </div>

                                                            </div>




                                                        </div>

                                                        {mayViewFinance(userData) && <StripePayoutsPanel stripe={editUser?.stripe} />}
                                                    </>
                                                    {/* :  <div className="row"><Loader /></div>} */}
                                                </div>
                                                <div className="tab-pane" id="profile1" role="tabpanel">
                                                    <div className="document-title">
                                                        <label >documents</label>
                                                        {/* <a href="" className="fill-btn-style mt-0">upload</a> */}
                                                    </div>


                                                </div>
                                                <div className="tab-pane" id="messages1" role="tabpanel">
                                                    <div className="mb-3 row">

                                                        <div className="mb-3 row">
                                                            {editUser && editUser?.followup && editUser?.followup?.length > 0 ?

                                                                <div className="col-md-12">
                                                                    <label >FOLLOW UP</label>
                                                                    {editUser && editUser?.followup && editUser?.followup?.map(function (item, i) {


                                                                        return (
                                                                            <div className="comments-block" key={i}>
                                                                                <p className="time">{item.created ? moment.utc(item.created).format("MM-DD-YYYY") : ""}</p>
                                                                                <p className="comments">{item.followup}</p>
                                                                                <p className="comments me-2">FollowupBy : {userData?.name}</p>
                                                                            </div>
                                                                        )
                                                                    })}

                                                                </div>
                                                                : <div div className="followups" id="no-followups"><div className="no-documents">
                                                                    <span className="material-icons-outlined" id="no-followups-icon">comment</span>
                                                                    <p>No follow-ups were found</p>
                                                                </div></div>}
                                                        </div>

                                                    </div>
                                                </div>
                                                <div className="tab-pane" id="stores" role="tabpanel">

                                                    {/* <div
                                                                                            className={`tab-pane fade ${activeTab === "stores" ? "show active" : ""
                                                                                                }`}
                                                                                            id="stores"
                                                                                            role="tabpanel"
                                                                                        > */}
                                                    {(editUser?.activeCount !== undefined || editUser?.inactiveCount !== undefined) && (
                                                        <div className="row mb-3">
                                                            <div className="col-md-12">
                                                                <div className="d-flex gap-3 align-items-center">
                                                                    <div className="badge bg-success fs-6 px-3 py-2">
                                                                        <span className="me-2">Active:</span>
                                                                        <strong>{editUser?.activeCount || 0}</strong>
                                                                    </div>
                                                                    <div className="badge bg-secondary fs-6 px-3 py-2">
                                                                        <span className="me-2">Inactive:</span>
                                                                        <strong>{editUser?.inactiveCount || 0}</strong>
                                                                    </div>
                                                                    <div className="badge bg-primary fs-6 px-3 py-2">
                                                                        <span className="me-2">Total:</span>
                                                                        <strong>{(editUser?.activeCount || 0) + (editUser?.inactiveCount || 0)}</strong>
                                                                    </div>
                                                                    <div className="badge bg-warning text-dark fs-6 px-3 py-2">
                                                                        <span className="me-2">Max Active Locations :</span>
                                                                        <strong>{editUser?.storeCountLimit || 0}</strong>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                    <DataTable
                                                        // key={keyForRerender}
                                                        columns={columns}
                                                        keyField='_id'
                                                        data={storesData}
                                                        direction="auto"
                                                        highlightOnHover
                                                        fixedHeaderScrollHeight="300px"
                                                        // pagination
                                                        responsive
                                                        persistTableHead
                                                        striped
                                                        subHeaderAlign="right"
                                                        defaultSortField="name"
                                                        noDataComponent={customNoRecords()}
                                                        // paginationTotalRows={data.length}
                                                        // onChangeRowsPerPage={handlePerRowsChange}
                                                        // onChangePage={handlePageChange}
                                                        // paginationPerPage={rowsPerPage}
                                                        // paginationDefaultPage={currentPageNew}
                                                        // paginationRowsPerPageOptions={[15, 25, 50, 75, 100]}
                                                        // sortFunction={customSort}
                                                        paginationComponentOptions={{
                                                            rowsPerPageText: 'Per page:',
                                                            rangeSeparatorText: 'of',
                                                            noRowsPerPage: false,
                                                            selectAllRowsItem: false,
                                                            selectAllRowsItemText: 'All',
                                                        }}
                                                        // progressPending={isLoading}
                                                        // progressComponent={<TableLoader />}
                                                        id="data-table"
                                                    />
                                                </div>

                                            </div>}

                                    </div>

                                </div>


                            </div>
                        </div>


                        <Footer />
                    </div>
                }



            </div>
        </>
    );
};

export default ViewClient;
